// extracted by mini-css-extract-plugin
export var notificationHost = "_f9-0";